import { render, staticRenderFns } from "./splash-screen.vue?vue&type=template&id=43d81f2c&scoped=true&"
import script from "./splash-screen.js?vue&type=script&lang=js&"
export * from "./splash-screen.js?vue&type=script&lang=js&"
import style0 from "./splash-screen.css?vue&type=style&index=0&id=43d81f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d81f2c",
  null
  
)

export default component.exports